import HelmetTags from "../../MainComponents/HelmetTags.jsx";
import Navbar from "../../MainComponents/Navbar.jsx";
import Footer from "../../MainComponents/Footer.jsx";

import "./styles/landingPage.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";

function ContactUsPage() {
  return (
    <>
      <HelmetTags
        title="Contact Us | Mr.Mohamed Salama"
        description="Contact Us Page"
      >
        <link rel="canonical" href="https://our-matrix.com/privacy-policy" />
      </HelmetTags>
      <div className="relative !overflow-hidden">
        <div className="gradient-bg fixed inset-0 -z-10" />
        <Navbar />

        <main className=" py-32 min-h-screen bg-transparent relative  flex flex-col  ">
          <section className="bg-white shadow-xl rounded-3xl p-8 max-w-xl w-full mx-auto text-center border border-gray-200">
            <h1 className="text-3xl md:text-4xl font-extrabold text-primary mb-4">
              تواصل معنا
            </h1>
            <p className="text-gray-600 mb-6">
              يمكنك التواصل معنا عبر وسائل التواصل الاجتماعي أو الأرقام التالية:
            </p>

            {/* أرقام التواصل */}
            <div className="mb-8  text-right space-y-3">
              <div className="flex items-center justify-end gap-2 text-lg font-medium text-gray-800">
                <span>
                  الدعم الفني:{" "}
                  <strong className="text-primary">01156268758</strong>{" "}
                  <span className="font-bold">(واتساب فقط)</span>
                </span>
              </div>

              <div className="flex items-center justify-end gap-2 text-lg font-medium text-gray-800">
                <FontAwesomeIcon icon={faPhoneAlt} className="text-primary" />
                <span>
                  الاستفسارات:{" "}
                  <strong className="text-primary">01140508274</strong>
                </span>
              </div>

              <div className="flex items-center justify-end gap-2 text-lg font-medium text-gray-800">
                <span>
                  الدعم العلمي:{" "}
                  <strong className="text-primary">01107852792</strong>{" "}
                  <span className="font-bold">(واتساب فقط)</span>
                </span>
              </div>
            </div>

            {/* روابط السوشيال ميديا */}
            <div className="flex justify-center gap-6">
              <SocialIcon
                href="https://www.facebook.com/MrMoamedSalama"
                icon={faFacebookF}
                hoverColor="text-blue-600"
              />
              <SocialIcon
                href="https://youtube.com/@msmatrix?si=oqfpBpHgHQXv4Tuz"
                icon={faYoutube}
                hoverColor="text-red-600"
              />
            </div>
          </section>
          <Footer />
        </main>
      </div>
    </>
  );
}

function SocialIcon({ href, icon, hoverColor }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`w-14 h-14 flex items-center justify-center rounded-full border border-gray-300 transition-all duration-300 hover:scale-110 hover:bg-primary/10 ${hoverColor}`}
    >
      <FontAwesomeIcon icon={icon} className="text-2xl" />
    </a>
  );
}

export default ContactUsPage;
